import axios from "axios";

export function getStockModuleSetting() {
  return new Promise((resolve, reject) => {
    axios.get("/distributor/admin/api/v1/getStockModuleSetting")
      .then(response => resolve(response.data))
      .catch(error => reject(error.response.data))
  })
}

